export const CORE_POLLING_INTERVAL = 5000;
export const SUPPORTED_METAMASK_VERSION = '11.13.0';

//# sourceMappingURL=general.js.map